import { Components, listItemButtonClasses, Theme } from '@mui/material';

export const MuiListItemButton: Components<Theme>['MuiListItemButton'] = {
  styleOverrides: {
    root: ({ theme }) => {
      if (theme.featureFlags.panwRebrandStubYear) {
        return {
          '&:hover': {
            backgroundColor: theme.palette.background.surface.hover,
            color: theme.palette.text.primary,
          },
          [`&.${listItemButtonClasses.selected}`]: {
            backgroundColor: theme.palette.background.surface.selected,
            color: theme.palette.text.primary,
          },
          [`&.${listItemButtonClasses.selected}:hover`]: {
            backgroundColor: theme.palette.background.surface.hover,
            color: theme.palette.text.primary,
          },
        };
      }

      return {};
    },
  },
};
